/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section3list_Effect2Inputs */

const id_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Efek pada Pasar:`)
};

const ms_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesan ke atas Pasaran:`)
};

const da_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effekt på Markedet:`)
};

const de_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswirkung auf den Markt:`)
};

const en_us2_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effect on the Market:`)
};

const es_es2_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Efecto en el mercado:`)
};

const es_mx2_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Efecto en el mercado:`)
};

const fil_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epekto sa Merkado:`)
};

const fr_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effet sur le marché :`)
};

const it_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effetto sul mercato:`)
};

const hu_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hatás a piacra:`)
};

const nl_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effect op de markt:`)
};

const no_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effekt på markedet:`)
};

const pl_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpływ na rynek:`)
};

const pt_br2_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Efeito no mercado:`)
};

const pt_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Efeito no mercado:`)
};

const ro_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Efectul asupra pieței:`)
};

const fi_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaikutus markkinoihin:`)
};

const sv_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effekt på marknaden:`)
};

const vi_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh hưởng đến thị trường:`)
};

const tr_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazar Üzerindeki Etki:`)
};

const cs_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vliv na trh:`)
};

const bg_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ефект върху пазара:`)
};

const ru_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Влияние на рынок:`)
};

const uk_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вплив на ринок:`)
};

const ar_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التأثير على السوق:`)
};

const hi_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रभाव:`)
};

const th_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผลกระทบต่อตลาด:`)
};

const ja_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市場への影響：`)
};

const zh_cn2_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对市场的影响：`)
};

const zh_hant1_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`對市場的影響：`)
};

const ko_misc_fairuse_section3list_effect2 = /** @type {(inputs: Misc_Fairuse_Section3list_Effect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시장에 미치는 영향:`)
};

/**
* | output |
* | --- |
* | "Effect on the Market:" |
*
* @param {Misc_Fairuse_Section3list_Effect2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section3list_effect2 = /** @type {((inputs?: Misc_Fairuse_Section3list_Effect2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section3list_Effect2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section3list_effect2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section3list_effect2(inputs)
	if (locale === "da") return da_misc_fairuse_section3list_effect2(inputs)
	if (locale === "de") return de_misc_fairuse_section3list_effect2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section3list_effect2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section3list_effect2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section3list_effect2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section3list_effect2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section3list_effect2(inputs)
	if (locale === "it") return it_misc_fairuse_section3list_effect2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section3list_effect2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section3list_effect2(inputs)
	if (locale === "no") return no_misc_fairuse_section3list_effect2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section3list_effect2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section3list_effect2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section3list_effect2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section3list_effect2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section3list_effect2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section3list_effect2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section3list_effect2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section3list_effect2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section3list_effect2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section3list_effect2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section3list_effect2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section3list_effect2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section3list_effect2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section3list_effect2(inputs)
	if (locale === "th") return th_misc_fairuse_section3list_effect2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section3list_effect2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section3list_effect2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section3list_effect2(inputs)
	return ko_misc_fairuse_section3list_effect2(inputs)
});
export { misc_fairuse_section3list_effect2 as "misc.fairUse.section3List.effect" }